import { render, staticRenderFns } from "./rekondpdb.vue?vue&type=template&id=50ac8f58&scoped=true"
import script from "./rekondpdb.vue?vue&type=script&lang=js"
export * from "./rekondpdb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac8f58",
  null
  
)

export default component.exports